import { render, staticRenderFns } from "./allCommodityNote.vue?vue&type=template&id=2fea48d1&scoped=true&"
import script from "./allCommodityNote.vue?vue&type=script&lang=js&"
export * from "./allCommodityNote.vue?vue&type=script&lang=js&"
import style0 from "./allCommodityNote.vue?vue&type=style&index=0&id=2fea48d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fea48d1",
  null
  
)

export default component.exports